import { FC } from "react";
import { FilterChip } from "shared/components/Spor";

type TrainBadgesProps = {
  trainIds: string[];
};

export const TrainBadges: FC<TrainBadgesProps> = ({ trainIds }) => (
  <>
    {trainIds.map((it) => (
      <FilterChip key={it} size="xs" checked style={{ pointerEvents: "auto" }}>
        {it}
      </FilterChip>
    ))}
  </>
);
